import { TagResponse } from '@/types/service-response'

export interface TagModel {
  createdAt: string
  id: number
  title: string
  iconClass: string | null
  tenant: string
}

export default class Tag implements TagModel {
  private constructor (
    readonly createdAt: string,
    readonly id: number,
    readonly title: string,
    readonly iconClass: string | null,
    readonly tenant: string
  ) {
  }

  public static createFromModel (model: TagModel): Tag {
    return new Tag(
      model.createdAt,
      model.id,
      model.title,
      model.iconClass,
      model.tenant
    )
  }

  public static createFromResponse (response: TagResponse): Tag[] {
    return response.map(i => new Tag(i.createdAt, i.id, i.title, i.iconClass, i.tenant))
  }

  get tagIri(): string {
    return `/api/tag/${this.id}`
  }
}